import { render, staticRenderFns } from "./CategoryField.vue?vue&type=template&id=8ed516ce&"
import script from "./CategoryField.vue?vue&type=script&lang=js&"
export * from "./CategoryField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports